import { Stack, Typography } from "@mui/joy";
import CreatePlaceButton from "../CreatePlaceButton";
import mascotNoRestaurantFound from "../../../assets/mascot_no-restaurant-found.png";

function NoPlacesFound() {
  return (
    <Stack direction="column" spacing={3} sx={{
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      flex: 1,
    }}>
      <Typography level="h4" fontWeight={700}>{"No Restaurants Found"}</Typography>
      <Typography level="body-sm">{"Sorry, no restaurants are found in this area. You can help us by adding that information for others to find!"}</Typography>
      <img src={mascotNoRestaurantFound} alt="No restaurants found mascot" style={{ width: 260, marginBottom: 16 }} />
      <CreatePlaceButton />
    </Stack>
  );
}

export default NoPlacesFound;
